export default "__VITE_ASSET__dYRJFLwj__"